import { createStore } from 'effector'
import connectLocalStorage from 'effector-localstorage'
import assign from 'lodash/assign'
import set from 'lodash/set'

import {
  getApplicationPingFx,
  getProjectsPingFx,
  postFilesFx,
  setAppDataFx,
  setAppInfoModeFx,
  setAppLoadingFx,
  setGlobalLoadingFx,
  setAppPriceFx,
} from './event'
import { localStorage } from '../../utils'
import { Common } from '../../shared/enum'
import { postInstallmentsFx, postTransactionsFx } from '../Transaction/event'

export const $appPrice = createStore<number | string>(0)
  .on(setAppPriceFx, (_, price) => price)

export const $globalLoading = createStore(false)
  .on(setGlobalLoadingFx, (_, value) => value)
  .on(postTransactionsFx.pending, (_, value) => value)
  .on(postInstallmentsFx.pending, (_, value) => value)

export const $appInfoMode = createStore<number>(localStorage.get(Common.APP_INFO_MODE) || 1)
  .on(setAppInfoModeFx, (_, mode) => {
    localStorage.set(Common.APP_INFO_MODE, mode)
    return mode
  })

export const $appLoading = createStore<boolean>(false)
  .on(setAppLoadingFx, (_, loading) => loading)

export const $getPingLoading = createStore<boolean>(false)
  .on(getApplicationPingFx.pending, (_, pending) => pending)
  .on(getProjectsPingFx.pending, (_, pending) => pending)
export const $getPingError = createStore<boolean>(false)
  .on(getApplicationPingFx.fail, () => true)
  .on(getProjectsPingFx.fail, () => true)

export const $postFilesLoading = createStore(false)
  .on(postFilesFx.pending, (_, pending) => pending)

export interface AppData {
  guide: {
    project: {
      clickBar: boolean
    }
  }
}
const appDataLocalStorage = connectLocalStorage('wtr/app-data')
export const $appData = createStore<AppData>(appDataLocalStorage.init({
  guide: {
    project: {
      clickBar: false,
    },
  },
}))
  .on(setAppDataFx, (data, { key, value }) => {
    return assign({}, set(data, key, value))
  })
$appData.watch(appDataLocalStorage)
